
const checkPoint = (pointTitle, pointUrl) => {
    const resultTitle = (pointTitle === '' || pointTitle === null) ? true : false
    const resultUrl = (pointUrl === '' || pointUrl === null) ? true : false
    return {titleResult: resultTitle, urlResult: resultUrl}
}
export default checkPoint;